document.addEventListener("DOMContentLoaded", () => {

    const header = document.querySelector(".ij-header");

    const menuBtn = document.querySelector(".ij-menu-toggle");
    const closeMenu = document.querySelector(".ij-close-menu");
    const mobileMenu = document.querySelector(".ij-mobile-menu");

    const overlay = document.querySelector(".ij-overlay");

    const searchBtn = document.querySelector(".ij-search-btn");
    const searchDrawer = document.querySelector(".ij-search-drawer");
    const searchClose = document.querySelector(".ij-search-close");

    /*=========================
        Sticky Header
    =========================*/

    function stickyHeader(){

        if(!header) return;

        if(window.scrollY > 60){
            header.classList.add("sticky");
        }else{
            header.classList.remove("sticky");
        }

    }

    window.addEventListener("scroll", stickyHeader);

    stickyHeader();


    /*=========================
        Mobile Menu
    =========================*/

    function openMenu(){

        if(!mobileMenu) return;

        mobileMenu.classList.add("active");

        overlay.classList.add("active");

        document.body.style.overflow = "hidden";

    }

    function closeMenuDrawer(){

        if(!mobileMenu) return;

        mobileMenu.classList.remove("active");

        overlay.classList.remove("active");

        document.body.style.overflow = "";

    }

    if(menuBtn){

        menuBtn.addEventListener("click", openMenu);

    }

    if(closeMenu){

        closeMenu.addEventListener("click", closeMenuDrawer);

    }


    /*=========================
        Search Drawer
    =========================*/

    function openSearch(){

        if(!searchDrawer) return;

        searchDrawer.classList.add("active");

        overlay.classList.add("active");

        document.body.style.overflow = "hidden";

    }

    function closeSearch(){

        if(!searchDrawer) return;

        searchDrawer.classList.remove("active");

        overlay.classList.remove("active");

        document.body.style.overflow = "";

    }

    if(searchBtn){

        searchBtn.addEventListener("click", openSearch);

    }

    if(searchClose){

        searchClose.addEventListener("click", closeSearch);

    }


    /*=========================
        Overlay
    =========================*/

    if(overlay){

        overlay.addEventListener("click", () => {

            closeMenuDrawer();

            closeSearch();

        });

    }


    /*=========================
        ESC Key
    =========================*/

    document.addEventListener("keydown", (event)=>{

        if(event.key === "Escape"){

            closeMenuDrawer();

            closeSearch();

        }

    });


    /*=========================
        Close Menu After Click
    =========================*/

    const mobileLinks = document.querySelectorAll(".mobile-nav a");

    mobileLinks.forEach(link=>{

        link.addEventListener("click", ()=>{

            closeMenuDrawer();

        });

    });

});